// Dependencies
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { RequestOptions } from '@angular/http';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import * as _ from 'lodash';

// Models
import { OrganizationModel } from '../../models/organization.model';

// Services
import { OrganizationRequestService } from '../../services/organization-request.service';

@Component({
    selector: 'organization-selection-row',
    templateUrl: './organization-selection-row.component.html',
    styleUrls: ['./organization-selection-row.component.scss']
})
export class OrganizationSelectionRowComponent {
    constructor(private organizationRequestService: OrganizationRequestService) {}

    @Input() organizationInput: OrganizationModel;
    @Input() organizationList: OrganizationModel[];
    @Input() organizationsToExclude: number[];
    @Input() respondentRoleList: object[];
    @Input() rowIndex: number;
    @Output() organizationChanged = new EventEmitter<OrganizationModel>();
    @Output() respondentRoleChanged = new EventEmitter<object>();
    @Output() controlCleared = new EventEmitter<OrganizationModel>();
    @ViewChild('organizationSearch') organizationSearchEl: NgbTypeahead;

    // Public Properties
    orgSelectionDisabled: boolean = false;
    searchFocus$ = new Subject<string>();
    searchClick$ = new Subject<string>();
    selectedOrganization: OrganizationModel = null;
    selectedRespondent: string = null;
    // timestamp: number = null;


    //----------------------------------
    // Lifecycle Hooks
    //----------------------------------

    ngOnInit() {
        if (this.organizationInput) {
            this.selectedOrganization = this.organizationInput;
            this._disableControl()
        }

        // this._setTimestamp();
    }


    //----------------------------------
    // Public Methods
    //----------------------------------

    clearControl(){
        this.controlCleared.emit(this.selectedOrganization);
    }

    getOrganizationName(orgModel: OrganizationModel) {
        let cityState = '';
        let orgDisplay = '';

        if ((orgModel.get('addr_city') || '').length > 0) {
            cityState += orgModel.get('addr_city');
        }

        if ((orgModel.get('addr_state') || '').length > 0) {
            if (cityState.length > 0) {
                cityState += ', ';
            }

            cityState += orgModel.get('addr_state');
        }

        if ((orgModel.get('friendly_name') || '').length > 0) {
            orgDisplay = orgModel.get('friendly_name');
        } else {
            orgDisplay = orgModel.get('name');
        }

        return orgDisplay + (cityState.length > 0 ? ` (${cityState})` : '');
    }

    getOrganizationLogo(orgModel: OrganizationModel) {
        return orgModel.getLogoUrl() ? `${orgModel.getLogoUrl()}` : '';
    }

    selectOrganization($event:any){
        this.organizationChanged.emit($event.item);
        this._disableControl();
    }

    searchOrganizations(text$: Observable<string>) {
        return text$
            .debounceTime(200).distinctUntilChanged()
            .merge(this.searchFocus$)
            .merge(this.searchClick$.filter(() => !this.organizationSearchEl.isPopupOpen()))
            .map(searchTerm => {
                return searchTerm.length === 0 ?
                this.organizationList.filter(v => !_.includes(this.organizationsToExclude, Number(v.id)) || (v.id === _.get(this.selectedOrganization, 'id'))) :
                this.organizationList
                    .filter(v => {
                        return (!_.includes(this.organizationsToExclude, Number(v.id)) || (v.id === _.get(this.selectedOrganization, 'id')))
                        && (_.includes(v.get('name').toLowerCase(), searchTerm.toLowerCase())
                            || _.includes((v.get('legal_name') || '').toLowerCase(), searchTerm.toLowerCase())
                            || _.includes((v.get('friendly_name') || '').toLowerCase(), searchTerm.toLowerCase())
                        )
                    })
            });
    }

    // uploadLogo(fileInput: any) {
    //     if (fileInput.target.files && fileInput.target.files[0]) {
    //         let file: File = fileInput.target.files[0];
    //         this.organizationRequestService.uploadLogo(Number(this.organizationInput.id), file)
    //             .subscribe(orgModel => {
    //                 this.selectedOrganization = orgModel;
    //                 this._setTimestamp();
    //                 this.organizationChanged.emit(orgModel);
    //             });
    //     }
    // }


    //----------------------------------
    // Private Methods
    //----------------------------------

    private _disableControl(){
        this.organizationSearchEl.setDisabledState(true);
        this.orgSelectionDisabled = true;
    }

    /*
    The purpose of this timestamp is to ensure that the img src for the organization
    logo is forced to refresh after uploading a new logo to replace an existing one.
    */
    // private _setTimestamp() {
    //     this.timestamp = (new Date()).valueOf();
    // }
}


// WEBPACK FOOTER //
// ./src/app/partials/organization-selection-row/organization-selection-row.component.ts